import ckeditorPlugin from 'grapesjs-plugin-ckeditor';
import { BRANDING_TYPE } from '../constants';

import {
	ServiceItemComponent,
	AchievementItemComponent,
	CustomComponent,
	CustomImageComponent,
	CustomWidgetComponent,
	CustomVideoComponent,
	VideoComponentConfig,
} from '../utils/editor/grapesjs';
import {
	getCSSToTemplateReport,
	getCSSToTemplateWebsite,
	changeTemplate,
	getCSSToEbookIntro,
} from '../utils';

const getCKEditorOptions = (type) => {
	const standardColorsString =
		'000000,FFFFFF,FF0000,00FF00,0000FF,FFFF00,FFA500,800080,00FFFF,FFC0CB,808080,A52A2A,008000,800000,808000,ADD8E6,D3D3D3,FF4500,8A2BE2,5F9EA0,FFD700,DC143C,7FFF00,4B0082,F0E68C,ADFF2F,20B2AA,FF6347';

	const fontSizeList = [
		8, 9, 10, 11, 12, 13, 14, 15, 16, 18, 20, 22, 24, 26, 28, 32, 36, 40, 44, 48, 56, 64, 72,
	]
		.map((size) => `${size}/${size / 10}rem`)
		.join(';');
	// Report or Ebook
	if (BRANDING_TYPE.TYPE_REPORT_COVER === type) {
		// prettier-ignore

		return {
			autoParagraph: false,
			position: 'center', // Toolbar position (optional)
			startupFocus: true,
			options: {
				extraPlugins: 'font,justify,undo,smiley,colorbutton,colordialog',
				toolbar: [
					['Bold', 'Italic', 'Underline'], // Text formatting
					['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
					['Format', 'FontSize', 'TextColor', 'BGColor'],
					['Undo', 'Redo'] // Undo/Redo actions
				],
				fontSize_sizes: fontSizeList,
				colorButton_colors: standardColorsString, // Predefined colors
				colorButton_enableAutomatic: true,
				colorButton_enableMore: true,
				removeButtons: 'Subscript,Superscript' // Alternatively, remove specific buttons
			}
		};
		// return {
		// 	autoParagraph: false,
		// 	startupFocus: true,
		// 	extraPlugins: 'sharedspace,justify,panelbutton,font,colorbutton,colordialog',
		// 	toolbarGroups: [
		// 		{ name: 'editing', groups: ['styles'] },
		// 		{ name: 'basicstyles', groups: ['basicstyles'] },
		// 		{ name: 'paragraph', groups: ['align', 'bidi', 'paragraph'] },
		// 		{ name: 'colors', groups: ['colors'] }
		// 	],
		//
		// 	fontSize_defaultLabel: 'Default',
		// 	removePlugins:
		// 		'find,flash,forms,iframe,image,newpage,removeformat,smiley,specialchar,templates',
		// 	position: 'right',
		// 	fontSize_sizes: sizeList.map(size => `${size}/${size / 10}rem`).join(';')
		// };
	}
	// Website
	return {
		autoParagraph: false,
		startupFocus: true,
		position: 'center', // Toolbar position (optional)
		options: {
			extraPlugins: 'font,justify,undo,smiley,indent,blockquote,colorbutton,colordialog',
			toolbar: [
				['Bold', 'Italic', 'Underline'], // Text formatting
				['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
				['Format', 'FontSize', 'TextColor', 'BGColor'],
				['BulletedList', 'NumberedList', 'Indent', 'Outdent'],
				['Blockquote', 'Smiley'],
				[('Undo', 'Redo')], // Undo/Redo actions
			],
			fontSize_sizes: fontSizeList,
			colorButton_colors: standardColorsString, // Predefined colors
			colorButton_enableAutomatic: true,
			colorButton_enableMore: true,
			removeButtons: 'Subscript,Superscript', // Alternatively, remove specific buttons
		},
	};
	// return {
	// 	autoParagraph: false,
	// 	startupFocus: true,
	// 	extraPlugins: 'sharedspace,justify,panelbutton,font,colorbutton,colordialog',
	// 	toolbarGroups: [
	// 		{ name: 'styles', groups: ['styles'] },
	// 		{ name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
	// 		{ name: 'clipboard', groups: ['clipboard', 'undo'] },
	// 		{ name: 'paragraph', groups: ['align', 'bidi', 'paragraph'] },
	// 		{ name: 'colors', groups: ['colors'] },
	// 		{ name: 'links', groups: ['links'] },
	// 		{ name: 'insert', groups: ['insert'] }
	// 	],
	// 	font_defaultLabel: 'Default',
	// 	fontSize_defaultLabel: 'Default'
	// 	removeButtons:
	// 		'Styles,Format,SpecialChar,HorizontalRule,Strike,Subscript,Anchor,Copy,Paste,PasteText,Cut,PasteFromWord,Undo,Redo,Table,Image,Font',
	// 	font_defaultLabel: 'Default',
	// 	fontSize_defaultLabel: 'Default'
	// 	// forcePasteAsPlainText: true,
	// 	// pasteFilter: 'p div'
	// };
};

const getGJSPresetWebpageSizeProperty = (type) => {
	// prettier-ignore
	const sizeList = [
		8, 9, 10, 11, 12, 14, 16, 17, 18, 19, 20, 22, 24, 25, 26, 28,
		30, 32, 34, 36, 38, 40, 42, 44, 48, 50, 60, 72, 75, 100, 128
	];
	if (BRANDING_TYPE.TYPE_REPORT_COVER === type) {
		return {
			property: 'font-size',
			type: 'select',
			defaults: '1.6rem',
			list: sizeList.map((size) => ({ value: `${size / 10}rem`, name: `${size}` })),
		};
	}
	return {
		property: 'font-size',
		type: 'select',
		defaults: '16px',
		list: sizeList.map((size) => ({ value: `${size}px`, name: `${size}` })),
	};
};

const plugins = [
	ckeditorPlugin,
	CustomComponent,
	CustomImageComponent,
	ServiceItemComponent,
	AchievementItemComponent,
	CustomVideoComponent,
	CustomWidgetComponent,
	VideoComponentConfig,
];

const getPluginOpts = (templateType) => ({
	'gjs-plugin-ckeditor': {
		options: getCKEditorOptions(templateType),
	},
	'gjs-preset-webpage': {
		customStyleManager: [
			{
				name: 'Typography & Decorations',
				open: true,
				buildProps: [
					'font-family',
					'font-size',
					'font-weight',
					// 'letter-spacing',

					// 'line-height',
					'text-align',
					// 'text-shadow',
					// 'border-radius-c',
					'color',
					'background-color',
					// 'border-color',
					// 'border-radius',
					'border',
					// 'box-shadow',
					// 'background'
				],
				properties: [
					{
						property: 'text-align',
						list: [
							{ value: 'left', className: 'fa fa-align-left' },
							{ value: 'center', className: 'fa fa-align-center' },
							{ value: 'right', className: 'fa fa-align-right' },
							{ value: 'justify', className: 'fa fa-align-justify' },
						],
					},
					{
						property: 'font-weight',
						type: 'radio',
						list: [
							{ value: '400', name: 'Normal' },
							{ value: '700', name: 'Bold' },
						],
					},
					getGJSPresetWebpageSizeProperty(templateType),
					{
						property: 'border',
						type: 'composite',
						properties: [
							{
								property: 'border-style',
							},
							{
								property: 'border-color',
							},
						],
					},
				],
			},
		],
	},
});

const getStorageManager = (templateName, adviserInfo) => ({
	type: 'remote',
	autoload: true,
	autosave: true,
	urlStore: `${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/save_template/${templateName}/`,
	urlLoad: `${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/load_template/${templateName}/`,
	credentials: 'include',
	onComplete: (res) => {
		console.log('load template completed');
		if (!res || !res['gjs-html']) {
			changeTemplate(templateName, { forceReset: true }, adviserInfo);
		}
	},
});

const getEditorConfig = (templateName, templateType, adviserInfo) => {
	console.log('getEditorConfig', { templateName, templateType });
	let cssList = getCSSToTemplateWebsite(templateName, true);
	if (BRANDING_TYPE.TYPE_REPORT_COVER === templateType) {
		cssList = getCSSToTemplateReport(templateName, true);
	} else if (BRANDING_TYPE.TYPE_EBOOK_INTRO === templateType) {
		cssList = getCSSToEbookIntro(templateName, true);
	}

	console.log('getEditorConfig cssList:', cssList);

	return {
		presetType: 'webpage',
		cssList,
		plugins,
		pluginsOpts: getPluginOpts(templateType),
		storageManager: getStorageManager(templateName, adviserInfo),
	};
};

export default getEditorConfig;
